import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { PrimeNgModule } from "@primeng";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PlayerSharedModule } from "@project/player/player-shared.module";
import { AfterLoginComponent } from "./after-login.component";
import { DataSharingMessageComponent } from "./data-sharing-message.component";
import { IncompleteDataService } from "@main/incomplete-data/incomplete-data.service";
import { IncompleteDataRequestsService } from "@main/incomplete-data/incomplete-data-requests.service";

@NgModule({
    declarations: [AfterLoginComponent, DataSharingMessageComponent],
    imports: [
        CommonModule,
        PrimeNgModule,
        OverlayPanelModule,
        ReactiveFormsModule,
        MiproSharedModule,
        PlayerSharedModule,
        MiproSharedModule,
    ],
    providers: [IncompleteDataService, IncompleteDataRequestsService],
    exports: [AfterLoginComponent, DataSharingMessageComponent]
})
export class AfterLoginModule {}
